import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import SeleccionTipoDocumentoOtros from '../components/SeleccionTipoDocumentoOtros';
import SeleccionInseminador from '../components/SeleccionInseminador';
import SeleccionRegistrador from '../components/SeleccionRegistrador';
import Lateral from '../components/Lateral';
const Inseminadores = () => {
    let emptyProduct = {
        TID_INSEMINADOR:'',
        NID_INSEMINADOR:'',
        ESTADO:'',
        VALOR:''
    };
    const [products, setProducts] = useState([]);
    const [productDialog, setProductDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const [reloadUsuarios, setReloadUsuarios] = useState(true)
    const [homo, setHomo] = useState(false)
    const INSEMINADORES = 'https://www.ancogenecop.com/APIANCO/controllers/inseminadores.php?op='
    useEffect(() => {
        if (reloadUsuarios) {
            const recarga = async () => {
                setReloadUsuarios(false)
                const data = new FormData();
                await fetch(INSEMINADORES + 'inseminadores', {
                    method: 'POST',
                    header: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                    body: data
                }).then((response) => response.json())
                    .then((response) => {
                        if (response != []) {
                            setProducts(response)
                        }

                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
            recarga()
        }
    }, [reloadUsuarios])


    const openNew = () => {
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
    }


    const saveProduct = async() => {
        setSubmitted(true);
         if(product.TID_INSEMINADOR=='') {console.log(1); return}
         if(product.NID_INSEMINADOR=='') {console.log(2); return}
         if(product.ESTADO=='') {console.log(3); return}
         if(product.VALOR=='') {console.log(4); return}
        const data = new FormData();
        data.append("TID_INSEMINADOR", product.TID_REGISTRADOR)
        data.append("NID_INSEMINADOR", product.NID_REGISTRADOR)
        data.append("ESTADO", product.ESTADO)
        data.append("VALOR", product.VALOR)
        await fetch(INSEMINADORES + 'ingresarInseminador', {
            method: 'POST',
            header: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: data
        }).then((response) => response.json())
            .then((response) => {
                if (response == 1) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'El Registro ha sido Ingresado o Actualizado', life: 3000 });
                    setReloadUsuarios(true)
                    setSubmitted(false);
                    setProductDialog(false);
                    setProduct(emptyProduct);
                } else {
                    toast.current.show({ severity: 'warning', summary: 'Error', detail: 'El Registro no pudo ser Ingresaro o Actualizado', life: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            })

    }

    const editProduct = (product) => {
    console.log(product)
        setProduct({ ...product });
        setProductDialog(true);
    }

    const confirmDeleteProduct = (product) => {
        setProduct(product);
    }


    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);
    }


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Adicionar" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <FileUpload mode="basic" accept="image/*" maxFileSize={1000000} label="Importar" chooseLabel="Importar" className="mr-2 inline-block" />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        )
    }
    function calcularEdad(fecha, opcion) {

        if (opcion == 1) {
            product.FECHA_RECEPCION = new Date(fecha).toISOString().slice(0, 10)
        }
    }



    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editProduct(rowData)} />
                {/* <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mt-2" onClick={() => confirmDeleteProduct(rowData)} /> */}
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Registradores</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Enviar" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
        </>
    );

    const handleplanta = async (dato, opc) => {
        setSubmitted(false)
        if (opc == 1) {
            product.ESTADO = dato
        }else if(opc==3){
            product.ZON_CODIGO=dato
        }else if (opc == 15) {
            product.NID_REGISTRADOR=dato
        } else if (opc == 16) {
            product.TID_REGISTRADOR=dato
        }else{
            product.COORDINADOR = dato
        }
    }

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <div className="formgrid grid">
                        <div className="field col-12">
                    <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>

                    <DataTable ref={dt} value={products} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} de {last} en {totalRecords} products"
                        globalFilter={globalFilter} emptyMessage="No se encontraron registros." header={header} responsiveLayout="scroll">
                        <Column body={actionBodyTemplate}></Column>
                        <Column field="descripcion" header="TID_INSEMINADOR" sortable ></Column>
                        <Column field="NID_INSEMINADOR" header="NID_INSEMINADOR" sortable ></Column>
                        <Column field="NOMBRE" header="NOMBRE" sortable ></Column>
                        <Column field="ESTAD" header="ESTADO" sortable ></Column>
                        <Column field="VALOR" header="VALOR" sortable ></Column>
                    </DataTable>
                    </div>
                    {/* <div className="field col-3"><Lateral/>

                    </div> */}
                    </div>
                    <Dialog visible={productDialog} style={{ width: '650px' }} header="Detalle del Registrador" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                    <div className="formgrid grid">
                             <div className="field col-6">
                                <label htmlFor="name">Tipo Documento Inseminador</label>
                                <SeleccionTipoDocumentoOtros handleplanta={handleplanta} NOMBRE={product.descripcion} />
                                {submitted && !product.TID_INSEMINADOR && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>El tipo de documento es requerido.</small>}
                            </div>
                            <div className="field col">
                                <label htmlFor="name">Nombres </label>
                                <SeleccionInseminador  handleplanta={handleplanta} NOMBREINSEMINADOR={product.NOMBRE}
                                />
                                {submitted && !product.NID_INSEMINADOR && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>Nombre del inseminador es requerido.</small>}
                            </div>
                            <hr/>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <label htmlFor="name">Estado</label>
                            <SeleccionRegistrador  handleplanta={handleplanta} MESTADO={product.ESTAD}
                            required
                            />
                            {submitted && !product.ESTADO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>Es estado es requerido.</small>}
                        </div>
                        <div className="field col">
                            <label htmlFor="name">Valor</label>
                            <InputText id="name" value={product.VALOR} onChange={(e) => onInputChange(e, 'VALOR')} required />
                            {submitted && !product.CRG_ABUELA_MATERNA && <small className="p-invalid"
                            style={{
                            color: 'red',
                            }}>El valor es requerido.</small>}                                                                                    
                        </div>
                    </div>
                    </Dialog>

                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Inseminadores, comparisonFn);
